<template>
  <div>
    <div class="mt-16">
      <div class="echarts">
        <div
          id="degree"
          style="width: 460px; margin: 0 auto; height: 290px"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: ['AssociationNumsData'],
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      bottomOption: {},
    }
  },
  watch: {
    AssociationNumsData: {
      handler: function () {
        this.initBarChart()
      },
      deep: true,
    },
  },
  mounted() {
    this.initBarChart()
  },
  methods: {
    initBarChart() {
      var myChart = this.$echarts.init(document.getElementById('degree'))
      this.bottomOption = {
        title: {
          //   text: 'Referer of a Website',
          //   subtext: 'Fake Data',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          top: '16px',
          textStyle: {
            color: '#fff',
          },
        },
        series: [
          {
            name: '年级占比',
            type: 'pie',
            radius: ['30%', '70%'],
            // data: [
            //   { value: 1048, name: '小型活动' },
            //   { value: 735, name: '中性活动' },
            //   { value: 580, name: '大型活动' },
            // ],
            data: this.AssociationNumsData,
            label: {
              normal: {
                position: 'inner',
                show: true,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      myChart.setOption(this.bottomOption)
    },
  },
}
</script>
<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}
.ml-8 {
  margin-left: 8px;
}
.echarts {
  margin-top: -32px;
}
</style>
